import { createReducer, on } from '@ngrx/store';

import { TaskStatusFilter } from '../models/task.interface';
import { TaskState } from '../models/task-state.interface';

import * as TaskActions from './task.actions';

const TEMP_PAGE_SIZE = 50;

const initialState: TaskState = {
  tasksList: {
    filter: {
      status: TaskStatusFilter.All,
    },
    pageSize: TEMP_PAGE_SIZE,
    continuationToken: '',
    data: [],
    loading: true,
  },
  currentTask: {
    data: null,
    loading: false,
  },
  systemUsers: {
    data: [],
    loading: false,
  },
  newTasksCount: 0,
};

export const taskReducer = createReducer(
  initialState,

  // Set Filters
  on(TaskActions.setTasksFilter, (state, { filter }) => ({
    ...state,
    tasksList: { ...state.tasksList, filter },
  })),

  // Get Tasks List
  on(TaskActions.getTasksList, state => ({
    ...state,
    tasksList: { ...state.tasksList, loading: true },
  })),
  on(TaskActions.getTasksListSuccess, (state, { response }) => ({
    ...state,
    tasksList: {
      ...state.tasksList,
      continuationToken: response.continuationToken || '',
      data: [...state.tasksList.data, ...response.items],
      loading: false,
    },
  })),
  on(TaskActions.getTasksListFailure, state => ({
    ...state,
    tasksList: { ...initialState.tasksList, loading: false },
  })),

  // Start Task
  on(TaskActions.startTaskSuccess, (state, { task }) => ({
    ...state,
    tasksList: {
      ...state.tasksList,
      data: state.tasksList.data.map(t => (t.id === task.id ? task : t)),
    },
    currentTask: state.currentTask.data?.id === task.id
      ? { data: task, loading: false }
      : state.currentTask,
  })),

  // Assign Task
  on(TaskActions.assignTaskSuccess, (state, { task }) => ({
    ...state,
    tasksList: {
      ...state.tasksList,
      data: state.tasksList.data.map(t => (t.id === task.id ? task : t)),
    },
  })),

  // Resolve Task
  on(TaskActions.resolveTaskSuccess, (state, { task }) => ({
    ...state,
    tasksList: {
      ...state.tasksList,
      data: state.tasksList.data.map(t => (t.id === task.id ? task : t)),
    },
    currentTask: { data: task, loading: false },
  })),

  // Get Current Task
  on(TaskActions.getCurrentTask, state => ({
    ...state,
    currentTask: { ...state.currentTask, loading: true },
  })),
  on(TaskActions.getCurrentTaskSuccess, (state, { task }) => ({
    ...state,
    currentTask: { data: task, loading: false },
  })),
  on(TaskActions.getCurrentTaskFailure, state => ({
    ...state,
    currentTask: { ...state.currentTask, loading: false },
  })),

  // Clear State
  on(TaskActions.clearCurrentTask, state => ({
    ...state,
    currentTask: { data: null, loading: false },
  })),
  on(TaskActions.clearTasksList, state => ({
    ...state,
    tasksList: { ...initialState.tasksList },
  })),

  // New Tasks Count
  on(TaskActions.getNewTasksCountSuccess, (state, { count }) => ({
    ...state,
    newTasksCount: count,
  })),

  // System Users
  on(TaskActions.loadSystemUsers, state => ({
    ...state,
    systemUsers: { ...state.systemUsers, loading: true },
  })),
  on(TaskActions.loadSystemUsersSuccess, (state, { users }) => ({
    ...state,
    systemUsers: { data: users, loading: false },
  })),
  on(TaskActions.loadSystemUsersFailure, state => ({
    ...state,
    systemUsers: { ...state.systemUsers, loading: false },
  }))
);
